module.exports = {"unknown":{"header":"Etwas ist schiefgelaufen","content":"Wir haben momentan technische Probleme. Bitte versuchen Sie es später erneut."},"duplicateAccount":{"header":"Es scheint, dass Sie bereits ein Konto haben","content":"Sie können sich anmelden oder eine andere E-Mail versuchen","action":"Ändern Sie die E-Mail"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/error.json
// module id = 484
// module chunks = 248 1694